module.exports = __webpack_public_path__ + "static/the-fry-chronicles-50101869d1e711e13ed1bbc14140442a.jpg";